module.exports = __webpack_public_path__ + "img/icons-16-next-gray.1d08c67a.svg";